<div class="titleblock">
  <h3 class="title1level">Adempimenti Processo Telematico</h3>
  <p>
    <a href="javascript:void(0)" (click)="changeSelectMode()">
      {{ selectMsg }} <span [class]="'glyphicon '+((isSelectMode) ? 'glyphicon-save' : 'glyphicon-check')"></span>
    </a>
  </p>
</div>

<div class="container_dati_generali">

  <div class="row">

    <div class="col-sm-6 col-xs-12">
      <button style="margin-bottom: 20px;" class="btn btn-primary" aria-label="Aggiorna Dati" (click)="updatePct()">
        Aggiorna Dati <span class="glyphicon glyphicon-refresh"></span>
      </button>
    </div>

    <div class="col-sm-6 col-xs-12">

      <div *ngIf="model">
        <span class="pda-last-update-label">Data ultimo aggiornamento: </span>
        <span class="pda-last-update-value"> {{ model.dataUltimoAggiornamento | date: "dd/MM/YYYY HH:mm" }} </span>
      </div>

    </div>

  </div>

  <div *ngIf="model && model.schedules?.length > 0">

    <div>
      <div class="row">

        <table class="table-striped table aggiunta_classificazione">
          <caption class="sr-only">Tabella Adempimenti</caption>
          <tr>
            <th>Data e Ora</th>
            <th>Giudice</th>
            <th>Tipo</th>
            <th>Evento</th>
            <th *ngIf="isSelectMode">Seleziona</th>
          </tr>

          <tr *ngFor="let schedule of currentSchedules">
            <td>{{ schedule.dataAdempimento | date: "dd/MM/yyyy HH:mm"}}</td>
            <td>{{ schedule.giudice }}</td>
            <td>{{ schedule.tipoAdempimento }}</td>
            <td>{{ schedule.evento }}</td>
            <td *ngIf="isSelectMode">
              <!-- <input type="checkbox" [checked]="isScheduleSelected(schedule)" (click)="onClickSelected(schedule)"> -->
              <div class="form-group col-sm-12 listcheckbox">
                <div style="display: flex;">
                  <input class="pct-party-checkbox" type="checkbox" id="select-parte-lbl-{{schedule.dataAdempimento}}"
                    [checked]="isScheduleSelected(schedule)" (click)="onClickSelected(schedule)">
                  <label for="select-parte-lbl-{{schedule.dataAdempimento}}">
                    <small class="sr-only">Seleziona adempimento</small>
                  </label>
                </div>
              </div>
            </td>
          </tr>

        </table>

      </div>

      <app-pagination
        [resetCurrentPage]="resetCurrentPage"
        [totalItems]="model.schedules != undefined ? model.schedules.length : 0"
        (refreshEvent)="onRefresh($event)"
      ></app-pagination>

    </div>

  </div>

</div>


<app-pda-section-nodata *ngIf="!model?.schedules || model.schedules?.length === 0" ></app-pda-section-nodata>
